import React from 'react';
import { Chart } from "react-chartjs-2";

const Camembert = ({ data }) => {
    const colors = [
        '#3b82f6', '#f59e0b', '#10b981', '#ef4444', '#8b5cf6',
        '#14b8a6', '#f97316', '#ec4899', '#84cc16', '#6366f1'
    ];

    const data2 = {
        labels: data.label || [],
        datasets: [
            {
                label: '%',
                data: data.data || [],
                backgroundColor: (data.label || []).map((_, i) => colors[i % colors.length]),
                hoverOffset: 10,
                borderWidth: 3,
                borderColor: '#ffffff',
            },
        ],
    };

    const options = {
        maintainAspectRatio: false,
        cutout: '65%',
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
                external: function (context) {
                    let tooltipEl = document.getElementById('chartjs-custom-tooltip');
                    if (!tooltipEl) {
                        tooltipEl = document.createElement('div');
                        tooltipEl.id = 'chartjs-custom-tooltip';
                        tooltipEl.style.position = 'absolute';
                        tooltipEl.style.background = 'rgba(255, 255, 255, 0.95)';
                        tooltipEl.style.borderRadius = '12px';
                        tooltipEl.style.pointerEvents = 'none';
                        tooltipEl.style.transform = 'translate(-50%, 0)';
                        tooltipEl.style.transition = 'all 0.1s ease';
                        tooltipEl.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1)';
                        tooltipEl.style.border = '1px solid rgba(226, 232, 240, 0.8)';
                        tooltipEl.style.padding = '12px 16px';
                        tooltipEl.style.zIndex = '1000';
                        document.body.appendChild(tooltipEl);
                    }

                    const tooltipModel = context.tooltip;
                    if (tooltipModel.opacity === 0) {
                        tooltipEl.style.opacity = '0';
                        return;
                    }

                    if (tooltipModel.body) {
                        const dataIndex = tooltipModel.dataPoints[0].dataIndex;
                        const label = data2.labels[dataIndex];
                        const value = data2.datasets[0].data[dataIndex];

                        const isBalance = label === 'Solde' || label === 'Balance';
                        const imgTag = isBalance ? '' : `<img src="https://financialmodelingprep.com/image-stock/${label}.png" style="width: 32px; height: 32px; border-radius: 50%; object-fit: cover;" onerror="this.style.display='none'" />`;

                        tooltipEl.innerHTML = `
                            <div style="display: flex; align-items: center; gap: 12px; font-family: 'Gabarito', sans-serif;">
                                ${imgTag}
                                <div style="display: flex; flex-direction: column;">
                                    <span style="font-size: 14px; font-weight: 700; color: #0f172a; margin-bottom: 2px;">${label}</span>
                                    <span style="font-size: 15px; font-weight: 800; color: #3b82f6;">${value}%</span>
                                </div>
                            </div>
                        `;
                    }

                    const position = context.chart.canvas.getBoundingClientRect();
                    tooltipEl.style.opacity = '1';
                    tooltipEl.style.left = position.left + window.scrollX + tooltipModel.caretX + 'px';
                    tooltipEl.style.top = position.top + window.scrollY + tooltipModel.caretY - 70 + 'px';
                }
            }
        },
        animation: {
            animateScale: true,
            animateRotate: true,
            duration: 1000,
            easing: 'easeOutQuart'
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%' }}>
            <div style={{ position: 'relative', width: '100%', flexGrow: 1, minHeight: 0 }}>
                <Chart type="doughnut" data={data2} options={options} />
            </div>

            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: '12px',
                marginTop: '16px',
                padding: '0 10px'
            }}>
                {data.label && data.label.map((label, index) => (
                    <div key={label} style={{ display: 'flex', alignItems: 'center', fontSize: '0.85rem', color: '#475569', fontWeight: 600 }}>
                        <span style={{
                            display: 'inline-block',
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: colors[index % colors.length],
                            marginRight: '6px'
                        }}></span>
                        {label}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Camembert;